import { Part, Time } from '@binhatch/servicetale-api';

export const getSubtotal = <T extends any>(array: T[], getter: (item: T) => number) =>
  array.reduce((subtotal, item) => subtotal + getter(item), 0);

export const getPartSubtotal = (parts: Part[]) => getSubtotal(parts, (item) => item.price * item.quantity);

export const getTimeSubtotal = (times: Time[]) => getSubtotal(times, (item) => item.rate * item.quantity);
